var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _vm.busca
        ? _c(
            "div",
            { class: "mb-1 mb-lg-0 " + (_vm.class_busca || "col-lg-auto") },
            [
              _c(
                "form",
                {
                  attrs: { autocomplete: "off" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("div", { staticClass: "input-group" }, [
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-group-text",
                          attrs: { id: "label-campo_buscar-" + _vm.id_busca },
                        },
                        [
                          _c("i", {
                            staticClass: "icon-md cursor-pointer",
                            attrs: { "data-feather": "search" },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.buscar,
                          expression: "buscar",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "search",
                        id: _vm.id_busca,
                        name: _vm.id_busca,
                        placeholder: _vm.placeholder_busca || "Buscar",
                        autocomplete: "off",
                      },
                      domProps: { value: _vm.buscar },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.buscar = $event.target.value
                        },
                      },
                    }),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("filtros", null, null, {
        changeFilter: _vm.updateFilter,
        id_componente: _vm.set_componente,
      }),
      _vm._v(" "),
      _vm.hidde_filtros || _vm.$slots.hidde_filtros
        ? _c("div", { staticClass: "col-lg-auto d-flex align-items-end" }, [
            !_vm.display_filtros
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-link p-0 mt-2",
                    attrs: {
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target":
                        "#" + _vm.set_componente + "-hidde_filtros",
                      "aria-expanded": "false",
                      "aria-controls": _vm.set_componente + "-hidde_filtros",
                    },
                    on: {
                      click: function ($event) {
                        _vm.display_filtros = true
                      },
                    },
                  },
                  [_c("span", [_vm._v("mais filtros")])]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hidde_filtros || _vm.$slots.hidde_filtros
        ? _c(
            "div",
            {
              staticClass: "col-12 collapse",
              attrs: { id: _vm.set_componente + "-hidde_filtros" },
            },
            [
              _vm._t("hidde_filtros", null, null, {
                changeFilter: _vm.updateFilter,
                id_componente: _vm.set_componente,
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-12" }, [
        _c("div", { staticClass: "row py-2 d-flex align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _vm.label_alert && !_vm.hidde_label_results
              ? _c("div", {
                  attrs: { id: _vm.id_busca + "-alert" },
                  domProps: { innerHTML: _vm._s(_vm.label_alert) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-auto" }, [
            _c(
              "span",
              { staticClass: "float-right" },
              [
                _c("paginate", {
                  attrs: { id_paginate: _vm.set_componente },
                  on: {
                    buscarPagina: function ($event) {
                      return _vm.pag($event)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }